/*
 * @Author: tkp
 * @Date: 2025-07-18 15:25:13
 */
import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/default',
    component: resolve => require(['@/layout/home'], resolve),
    children: [
      {
        path: '/default',
        name: 'default',
        component: resolve => require(['@/view/default/index'], resolve),
      }
    ]
  }
  ]
})
//挂载路由导航守卫
router.beforeEach(function (to, from, next) {
  next();
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js